import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TwcModule } from '@topcon/twc-angular';

import { PaginatorComponent } from './paginator.component';

@NgModule({
    imports: [CommonModule, TwcModule],
    exports: [PaginatorComponent],
    declarations: [PaginatorComponent],
    providers: [],
})
export class PaginatorModule {}
